import {
  Event,
} from '@angular/router';
import {
  Observable,
} from 'rxjs';
import {
  distinctUntilChanged,
  map,
  startWith,
} from 'rxjs/operators';

/**
 * Returns the current location href
 * `router.events` is used as trigger to grab the new values from `document.location`
 */
export const retrieveLocationHref = () => (source: Observable<Event>) =>
  source.pipe(
    map(() => document.location.href),
    distinctUntilChanged(),
    startWith(document.location.href)
  );

/**
 * Returns the current location origin
 * `router.events` is used as trigger to grab the new values from `document.location`
 */
export const retrieveLocationOrigin = () => (source: Observable<Event>) =>
  source.pipe(
    map(() => document.location.origin),
    distinctUntilChanged(),
    startWith(document.location.origin)
  );

/**
 * Returns the current location pathname
 * `router.events` is used as trigger to grab the new values from `document.location`
 */
export const retrieveLocationPathname = () => (source: Observable<Event>) =>
  source.pipe(
    map(() => document.location.pathname),
    distinctUntilChanged(),
    startWith(document.location.pathname)
  );
